<div class="container container-shadow">
  <div class="row">
    <div class="col pt-3">
      <a class="float-left" [routerLink]="'/matter_types/'">Matter Types List</a>
      <div class="clearfix"></div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-3"></div>
    <div class="col-sm-6">
      <div class="page-header">
        <h2 *ngIf="matterType.id">Edit Matter Type</h2>
        <h2 *ngIf="!matterType.id">New Matter Type</h2>
      </div>
      <form (submit)="submitForm(currentForm.form.valid)" #currentForm="ngForm" novalidate>
        <div class="form-group">
          <label>Name</label>
          <input type="text" name="name" required #name="ngModel" [(ngModel)]="matterType.name" class="form-control" />
          <div class="alert alert-danger alert-padding-sm" [hidden]="!fieldShowErrorMessage(name)">Name needs to be entered</div>
        </div>
        <div class="form-group">
          <label>Graph Group</label>
          <textarea class="form-control" name="graph_group" #graph_group="ngModel" [(ngModel)]="matterType.graph_group"></textarea>
        </div>
        <div class="form-group">
          <label>Primary Activity</label>
          <select class="form-control" name="primary_activity_id" #primary_activity_id="ngModel" [(ngModel)]="matterType.primary_activity_id">
            <option *ngFor="let activity of formOptions.activities" [value]="activity.value">{{ activity.label }}</option>
          </select>
        </div>
        <div class="form-group">
          <label>Regarding</label>
          <textarea class="form-control" name="regarding" #regarding="ngModel" [(ngModel)]="matterType.regarding"></textarea>
        </div>
        <div class="form-group">
          <label>What we will do</label>
          <textarea class="form-control" name="we_will_do" #we_will_do="ngModel" [(ngModel)]="matterType.we_will_do"></textarea>
        </div>
        <div class="form-group">
          <label>Consult Fee</label>
          <input type="number" step="0.01" min="0" class="form-control" name="consult_fee" #consult_fee="ngModel" [(ngModel)]="matterType.consult_fee" />
        </div>
        <div class="form-group">
          <label>Retainer</label>
          <input type="number" step="0.01" min="0" class="form-control" name="retainer" #retainer="ngModel" [(ngModel)]="matterType.retainer" />
        </div>
        <div class="form-group">
          <label>Allowable Fee Types</label>
          <div class="row">
            <div class="col-sm-1"></div>
            <div class="col-sm-10">
              <div class="custom-control custom-checkbox" (click)="matterType.is_flat_fee = !matterType.is_flat_fee">
                <input type="checkbox" name="is_flat_fee" [checked]="matterType.is_flat_fee" [(ngModel)]="matterType.is_flat_fee" class="custom-control-input" />
                <label class="custom-control-label">Is flat fee</label>
              </div>
              <div class="custom-control custom-checkbox" (click)="matterType.is_hourly = !matterType.is_hourly">
                <input type="checkbox" name="is_hourly" [checked]="matterType.is_hourly" [(ngModel)]="matterType.is_hourly" class="custom-control-input" />
                <label class="custom-control-label">Is hourly</label>
              </div>
              <div class="custom-control custom-checkbox" (click)="matterType.is_no_charge = !matterType.is_no_charge">
                <input type="checkbox" name="is_no_charge" [checked]="matterType.is_no_charge" [(ngModel)]="matterType.is_no_charge" class="custom-control-input" />
                <label class="custom-control-label">Is no charge</label>
              </div>
              <div class="custom-control custom-checkbox" (click)="matterType.is_percentage = !matterType.is_percentage">
                <input type="checkbox" name="is_percentage" [checked]="matterType.is_percentage" [(ngModel)]="matterType.is_percentage" class="custom-control-input" />
                <label class="custom-control-label">Is percentage</label>
              </div>
              <div class="custom-control custom-checkbox" (click)="matterType.invoice_by_default = !matterType.invoice_by_default">
                <input type="checkbox" [checked]="matterType.invoice_by_default" [(ngModel)]="matterType.invoice_by_default" name="invoice_by_default" class="custom-control-input" />
                <label class="custom-control-label">Invoice by default</label>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group text-center">
          <button type="submit" class="btn btn-primary" [disabled]="formSubmitting">Save</button>
          &nbsp;&nbsp;&nbsp;
          <app-button-back [buttonDisabled]="formSubmitting"></app-button-back>
        </div>
      </form>
    </div>
  </div>
</div>
